import { observer } from "mobx-react-lite"
import { useProfileImage } from "../customHooks/useProfileImage"
import { SwipeUser } from "../models/api/SwipeUser"
import { APP_LOGO, rootStore } from "../StApp"

function Liked({ liked }: { liked: boolean }) {

    if (liked)
        return <span className="material-icons" style={{color: 'red'}} >
            favorite
        </span>
    else
        return <span className="material-icons"  >
            favorite_border
        </span>

}

function Dumped({ dumped }: { dumped: boolean }) {

    if (dumped)
        return <span className="material-icons" style={{color: 'red'}} >
            heart_broken
        </span>
    return <span className="material-icons-outlined" >
        heart_broken
    </span>

}


export const DumpUserItem = observer((props: { user: SwipeUser }) => {

    const store = rootStore.dumpStore
    const user = props.user 
    const liked = store.likedUids.has(user.uid)
    const finalDumped = store.finalDumpUids.has(user.uid)
    const {imgUrl} = useProfileImage(user.uid,0, APP_LOGO)

    return (
        <div className='flex-row container-dump-item center-align' 
        style={{ justifyContent: 'space-between', backgroundColor: finalDumped?'#c1c1c1':'antiquewhite' }}  >
            <div className='flex-row' >
                <div className='card-dump-img' style={{backgroundImage: `url(${imgUrl})`}} ></div>
                <div style={{ margin: '0px 5px' }}>
                    <h3>{user.name}</h3>
                    <p>{user.currentLoc?.state}</p>
                    <p>{user.currentLoc?.country}</p>
                </div>
            </div>
            <div className='flex-row' >
                <div onClick={()=>store.toggleLike(user.uid)} >
                    <Liked liked={liked} />
                </div>
                <div style={{marginLeft: 10}} onClick={()=>store.toggleDump(user.uid)} >
                    <Dumped dumped={finalDumped} />
                </div>
            </div>
        </div>
    )
})
